import { GeotabError } from "@fairfleet/geotab";
import { QueryClient } from "@tanstack/react-query";
import { milliseconds } from "date-fns";

/** react-query's own default. */
const MAX_RETRIES = 3;

/**
 * Whether Geotab refused the call because the user lacks the clearance for it. Asking again gives
 * the same answer, so such a call is not retried — in a database without `ViewAddInData` every
 * settings query otherwise asked four times.
 */
export function isMissingPermissionError(error: unknown): boolean {
  if (!(error instanceof GeotabError)) {
    return false;
  }
  const data = error.data as { type?: unknown } | undefined;
  return data?.type === "InvalidPermissionsException";
}

/**
 * Creates a new {@link QueryClient} with default options.
 */
export function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: milliseconds({ minutes: 10 }),
        gcTime: milliseconds({ minutes: 10 }),
        retry: (failureCount, error) => !isMissingPermissionError(error) && failureCount < MAX_RETRIES,
      },
      mutations: {},
    },
  });
}
